import React from 'react';
import Image from 'next/image';

const Spinner: React.FC = () => (
  <div className={'text-center'} role="status">
    <Image src="/gifs/timeline3.gif" alt="spinner" width={200} height={200} />
  </div>
);

export default Spinner;
